import { Button, Modal, Spinner } from 'react-bootstrap';
import API from 'utils/atolyeAPI';
import alert from 'js/sweetAlert';
import { useState } from 'react';

const AtolyeAPI = new API();

const DeleteTagModal = ({ show, onDismiss, tag, refresh }) => {
  // State

  const [isLoading, setIsLoading] = useState(false);

  // Functions

  const deleteTag = async () => {
    setIsLoading(true);

    try {
      const { status } = await AtolyeAPI.get(`/tags/${tag.id}/delete`);

      if (status && status === 'SUCCESS') {
        return alert('success', 'Ürün Etiketi başarıyla silindi');
      }
      return alert('error', 'Ürün Etiketi silinirken bir hata oluştu');
    } catch (error) {
      alert('error', 'Ürün Etiketi silinirken bir hata oluştu');
      console.log(error);
    } finally {
      setIsLoading(false);
      onDismiss();
      refresh(true);
    }
  };

  return (
    <Modal show={show} onHide={onDismiss}>
      <Modal.Header className="bg-danger" closeButton>
        <Modal.Title>Etiket No: {tag.id} - Sil</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{tag.id}</strong> numaralı ve <strong>{tag.name}</strong> adlı Ürün Etiketi
          silinecektir. Silmek istediğinize emin misiniz?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onDismiss}>
          Vazgeç
        </Button>
        <Button variant="danger" onClick={() => deleteTag()}>
          {isLoading ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            'Sil'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTagModal;
